import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { LABEL, URL } from '../../../../../../modules/event-links/config';
import { EventLinkFormViewModel } from './event-link-form.viewmodel';


export const EventLinkForm = observer((props: {vm: EventLinkFormViewModel}) => {
    const { formatMessage } = useIntl();
    const { vm } = props;

    const eventLinkTypeLabel = <FormattedMessage id='oe.common.eventLinkType' description='input label' defaultMessage='Link Type' />;

    const eventLinkLabel = vm.getFieldByKey(LABEL);
    const eventLinkLabelText = formatMessage(vm.getFieldConfigByKey(LABEL).labelDescriptor);

    const eventLinkUrl = vm.getFieldByKey(URL);
    const eventLinkUrlLabel = formatMessage(vm.getFieldConfigByKey(URL).labelDescriptor);

    return (
        <div className='p-20px'>
            <FormField label={eventLinkTypeLabel}>
                <select
                    className='oe-form-field__control'
                    value={vm.getLinkType()}
                    onChange={e => vm.setLinkType(e.target.value)}
                >
                    {vm.linkTypeOptions.map(value => (
                        <option key={value} value={value}>{value}</option>
                    ))}
                </select>
            </FormField>
            <FormField label={eventLinkLabelText}>
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        onBlur={vm.setValueTouched.bind(vm, LABEL)}
                        value={eventLinkLabel.value as string || ''}
                        type='text'
                        onChange={e => vm.setFieldValueByKey(LABEL, e.target.value)}
                    />
                </div>
                <span className='oe-form-field__error'>
                    {
                        !eventLinkLabel.valid && eventLinkLabel.touched &&
                        <FormattedMessage values={{ fieldName: eventLinkLabelText }} {...eventLinkLabel.validationMessage} />
                    }
                </span>
            </FormField>
            <FormField label={eventLinkUrlLabel} className='m-bottom-0px'>
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        onBlur={vm.setValueTouched.bind(vm, URL)}
                        value={eventLinkUrl.value as string || ''}
                        type='text'
                        onChange={e => vm.setFieldValueByKey(URL, e.target.value)}
                    />
                </div>
                <span style={{height: '20px'}} className='oe-form-field__error'>
                    {
                        !eventLinkUrl.valid && eventLinkUrl.touched &&
                        <FormattedMessage values={{ fieldName: eventLinkUrlLabel }} {...eventLinkUrl.validationMessage} />
                    }
                </span>
            </FormField>
        </div>
    );
});
